import { CircularProgress } from '@mui/material';
import React from 'react';

const FullPageLoader = () => {

	return (
		<div className="logo-loading">
			<div className="text-center" >
			<CircularProgress  sx={{  marginTop: "300px"}}/>
			<p style={{ color:'#1976d2', fontSize:'15px' }}>Loading...</p>
			</div>
		</div>
	);
};

export default FullPageLoader;
